<div class="modal-content">
    <div class="modal-header">
        <b>{{title}}</b>
    </div>
    <div class="modal-body">
        <ng-content #content *ngIf="LoadedComplete()"></ng-content>
    </div>
</div>

